/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParameterModification } from './ParameterModification';
import {
    ParameterModificationFromJSON,
    ParameterModificationFromJSONTyped,
    ParameterModificationToJSON,
    ParameterModificationToJSONTyped,
} from './ParameterModification';
import type { OrganizationalValue } from './OrganizationalValue';
import {
    OrganizationalValueFromJSON,
    OrganizationalValueFromJSONTyped,
    OrganizationalValueToJSON,
    OrganizationalValueToJSONTyped,
} from './OrganizationalValue';
import type { StatementModification } from './StatementModification';
import {
    StatementModificationFromJSON,
    StatementModificationFromJSONTyped,
    StatementModificationToJSON,
    StatementModificationToJSONTyped,
} from './StatementModification';

/**
 * 
 * @export
 * @interface ProfileTailoringRequest
 */
export interface ProfileTailoringRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfileTailoringRequest
     */
    profileId?: string;
    /**
     * 
     * @type {Array<OrganizationalValue>}
     * @memberof ProfileTailoringRequest
     */
    organizationalValues?: Array<OrganizationalValue>;
    /**
     * 
     * @type {Array<StatementModification>}
     * @memberof ProfileTailoringRequest
     */
    statementModifications?: Array<StatementModification>;
    /**
     * 
     * @type {Array<ParameterModification>}
     * @memberof ProfileTailoringRequest
     */
    parameterModifications?: Array<ParameterModification>;
    /**
     * 
     * @type {string}
     * @memberof ProfileTailoringRequest
     */
    tailoredBy?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileTailoringRequest
     */
    tailoringNotes?: string;
}

/**
 * Check if a given object implements the ProfileTailoringRequest interface.
 */
export function instanceOfProfileTailoringRequest(value: object): value is ProfileTailoringRequest {
    return true;
}

export function ProfileTailoringRequestFromJSON(json: any): ProfileTailoringRequest {
    return ProfileTailoringRequestFromJSONTyped(json, false);
}

export function ProfileTailoringRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileTailoringRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'organizationalValues': json['organizationalValues'] == null ? undefined : ((json['organizationalValues'] as Array<any>).map(OrganizationalValueFromJSON)),
        'statementModifications': json['statementModifications'] == null ? undefined : ((json['statementModifications'] as Array<any>).map(StatementModificationFromJSON)),
        'parameterModifications': json['parameterModifications'] == null ? undefined : ((json['parameterModifications'] as Array<any>).map(ParameterModificationFromJSON)),
        'tailoredBy': json['tailoredBy'] == null ? undefined : json['tailoredBy'],
        'tailoringNotes': json['tailoringNotes'] == null ? undefined : json['tailoringNotes'],
    };
}

export function ProfileTailoringRequestToJSON(json: any): ProfileTailoringRequest {
    return ProfileTailoringRequestToJSONTyped(json, false);
}

export function ProfileTailoringRequestToJSONTyped(value?: ProfileTailoringRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'profileId': value['profileId'],
        'organizationalValues': value['organizationalValues'] == null ? undefined : ((value['organizationalValues'] as Array<any>).map(OrganizationalValueToJSON)),
        'statementModifications': value['statementModifications'] == null ? undefined : ((value['statementModifications'] as Array<any>).map(StatementModificationToJSON)),
        'parameterModifications': value['parameterModifications'] == null ? undefined : ((value['parameterModifications'] as Array<any>).map(ParameterModificationToJSON)),
        'tailoredBy': value['tailoredBy'],
        'tailoringNotes': value['tailoringNotes'],
    };
}

